"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ChecklistItem = _interopRequireDefault(require("./ChecklistItem"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Checklist extends _react.default.Component {
  render() {
    const {
      values,
      propIdName,
      propLabelName,
      checkedValues,
      onAdd,
      onDelete
    } = this.props;
    if (!values) return /*#__PURE__*/_react.default.createElement(_Spinner.default, null);
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: 'list-group'
    }, values.map((value, index) => {
      const checked = checkedValues ? checkedValues.filter(c => c[propIdName] === value.Id) : false;
      return /*#__PURE__*/_react.default.createElement(_ChecklistItem.default, {
        key: index,
        className: 'list-group-item',
        isChecked: checked.length > 0,
        onCheck: () => onAdd(value),
        onUncheck: () => onDelete(checked.length && checked[0].Id),
        displayName: propLabelName ? value[propLabelName] : 'Label'
      });
    }));
  }
}
Checklist.propTypes = process.env.NODE_ENV !== "production" ? {
  values: _propTypes.default.array,
  propName: _propTypes.default.string,
  propIdName: _propTypes.default.string,
  propLabelName: _propTypes.default.string,
  checkedValues: _propTypes.default.array,
  onAdd: _propTypes.default.func,
  onDelete: _propTypes.default.func
} : {};
var _default = exports.default = Checklist;
module.exports = exports.default;